import { useDispatch, useSelector } from 'react-redux'
import { bottomDrawerSlice, bottomDrawerSelectors } from './bottom-drawer.slice'
import type { BottomDrawerPayload, BottomDrawerRootState } from './bottom-drawer.slice'

export const bottomDrawerHooks = {
  useIsOpen: (id: string) =>
    useSelector((state: BottomDrawerRootState) => bottomDrawerSelectors.selectById(state, id)?.isOpen || false),

  useSubscriptionWorkflow: (id: string) =>
    useSelector((state: BottomDrawerRootState) => bottomDrawerSelectors.selectById(state, id)?.subscriptionWorkflow),

  useBottomDrawerActions: () => {
    const dispatch = useDispatch()

    return {
      openBottomDrawer: (payload: BottomDrawerPayload) => {
        dispatch(bottomDrawerSlice.actions.openBottomDrawer(payload))
      },
      closeBottomDrawer: (payload: BottomDrawerPayload) => {
        dispatch(bottomDrawerSlice.actions.closeBottomDrawer(payload))
      },
    }
  },
}
